import fetchSurvey from './fetchSurvey';
import fetchSurveyBlock from './fetchSurveyBlock';
import sendSurveyBlockResults from './sendSurveyBlockResults';

export default [
  fetchSurvey,
  fetchSurveyBlock,
  sendSurveyBlockResults,
];
